"use client";
import React from "react";
import { Box, Typography, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import logo from "../../assets/salontym_loder.png";
import Image from "next/image";

interface GetAppNotificationProps {
  setVisible: (visible: boolean) => void;
  visible: boolean;
}

const GetAppNotification: React.FC<GetAppNotificationProps> = ({
  setVisible,
  visible,
}) => {
  const handleCloseNotification = () => {
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <Box
      sx={{
        display: { xs: "flex", sm: "none" },
        alignItems: "center",
        justifyContent: "space-between",
        background:
          "linear-gradient(135deg, #123524 0%, #1f7a4d 92%, #1a5c38 100%)",
        color: "white",
        padding: "8px",
        maxWidth: "100%",
        minHeight: "65px",
        borderBottom: "1px solid rgba(255,255,255,0.1)",
        boxShadow: "0 8px 24px rgba(18, 53, 36, 0.2)",
      }}
    >
      {/* Logo */}
      <Image
        src={logo}
        alt="SalonTym"
        width={500}
        height={500}
        style={{
          width: 50,
          height: 50,
          borderRadius: "8px",
        }}
      />

      {/* Text Content */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "start",
          alignItems: "start",
        }}
      >
        <Typography variant="body2" fontWeight="bold">
          Download the App
        </Typography>
        <Typography variant="caption" sx={{ textWrap: "nowrap" }}>
          for exclusive features & experience
        </Typography>
      </Box>

      {/* "Get App" Button */}
      <Button
        variant="contained"
        sx={{
          backgroundColor: "rgba(255,255,255,0.96)",
          color: "#123524",
          fontWeight: 700,
          textTransform: "none",
          borderRadius: "999px",
          padding: "6px 12px",
          marginRight: "10px",
          whiteSpace: "nowrap",
          "&:hover": { backgroundColor: "#f6faf8" },
          fontSize: "12px",
        }}
        onClick={() => {
          const userAgent = navigator.userAgent || navigator.vendor;
          const isIOS = /iPad|iPhone|iPod/.test(userAgent);
          const isAndroid = /Android/.test(userAgent);

          if (isIOS) {
            window.location.href =
              "https://apps.apple.com/in/app/salontym-salon-at-home/id6444617786";
          } else if (isAndroid) {
            window.location.href =
              "https://play.google.com/store/apps/details?id=com.tym.salon.salontym&hl=en_IN";
          } else {
            window.location.href =
              "https://play.google.com/store/apps/details?id=com.tym.salon.salontym&hl=en_IN";
          }
        }}
      >
        Get App
      </Button>

      {/* Close Button */}
      <IconButton
        onClick={handleCloseNotification}
        aria-label="Dismiss app download banner"
        sx={{ color: "white", padding: "0px" }}
      >
        <CloseIcon />
      </IconButton>
    </Box>
  );
};

export default GetAppNotification;
